import { useLocation } from "react-router-dom";

export const useOffercode = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  return query.get("offercode");
};
